export default __webpack_public_path__ + "static/benefits-decision-41c2c7cfdf8526bd079879706d465ca2.mp4";